// extracted by mini-css-extract-plugin
module.exports = {"legal":"LegalInfo_legal__PUWKF","contactInfo":"LegalInfo_contactInfo__zvf4v","legalInfo":"LegalInfo_legalInfo__yUGsZ","reservedRights":"LegalInfo_reservedRights__yzu1R"};